<template>
    <drawer-layout>
        <div class="report-container mx-7 mt-4">
            <bibles-header
                :type="type"
                @changeSearch="changeValueSearch"
            />

            <indicator-books-table
                :type="type"
                :search="search"
            />
        </div>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import IndicatorsHeader from "@/Shared/Indicators/Index/IndicatorsHeader";
import IndicatorBooksTable from "@/Shared/Indicators/Index/IndicatorBooksTable";

export default {
    name: "Index",
    components: {
        DrawerLayout,
        IndicatorsHeader,
        IndicatorBooksTable,
    },

    props: {
        type: {
            type: Object,
            default: [],
        },
    },

    data () {
        return {
            search: '',
        }
    },

    methods: {
        changeValueSearch(value) {
            this.search = value
        },
    },
}
</script>

<style scoped>

</style>
